import React, { useEffect, useState, useRef, useContext } from "react";
import Translate from 'react-translate-component';
import PaymentInfo, { paymentMethod } from "./PaymentInfo";
import SelectServices from "./SelectServices";
import { useSelector, useDispatch } from "react-redux";
import { GlobalStore } from "../../reduxStore";
import ReservationTime from "./ReservationTime";
import VehicleResult from "../VehicleSearch/VehicleResult";
import styles from "./main.module.scss";
import {cx, isUnderTwentyOne} from "./util";
import { ScrollingPage } from "../MyReservations/ScrollingPage";
import { translateService } from "../../services/TranslateService";
import moment from "moment";
import { User } from "../../interfaces/User";
import { baseOnSalesPrice, discountValue as calculateDiscountValue } from "./pricingCalculations";
import { basePrice } from './pricingCalculations';
import "./tippy.scss";
import Modal from 'react-modal';
import LoginContainer from "../Login/LoginContainer";
import CustomerInfoNew from "./CustomerInfo-new";
import { Card } from "react-bootstrap";
import { DataContext } from "../../contexts/dataContext";
import {PurchaseGtagEvent} from "../../services/PurchaseGtagEvent";
import {Steps} from "../reservation-steps/steps";

export const MakeReservation = ({ setRedirect }: any) => {
  const apiService = useSelector((state: GlobalStore) => state.chauffeurReducer.apiService);
  const uiLanguage = useSelector((s: GlobalStore) => s.chauffeurReducer.deviceLanguage);
  const [detailsVisible, setDetailsVisible] = React.useState(-1);
  const dispatch = useDispatch();
  const [showLogin, setShowLogin] = useState(false);
  const [activeTab, setTab] = useState(1);
  const [totalPrice, setTotalPrice] = useState<number>();
  const [redirectHome, setRedirectHome] = useState(false);
  const topRef = useRef<HTMLSpanElement>(null);
  const dataContext = useContext(DataContext);
  const reservationDays = dataContext.getReservationDays();

  /*
  when personalidcoderecorded is set, is personalid code recorded true when nordea verified?
  local customer with SS - ok
  foreigner with no ss - ok
  local without ss set, ask for ss
  foreigner with no details - ask bday

  A new 24go  customer with no info returns user.nopersonalidcode as false, which is wrong
  personalIdCodeRecorded is true for my own account as an international registered user, so that is also incorrect
  */


  useEffect(() => {
    if (document.getElementById("top")) {
      document.getElementById("top")?.scrollIntoView({ behavior: 'smooth', block: 'center' }    );
    } else {
      window.scrollTo({ top: (topRef.current?.offsetTop || 0) - 100, behavior: 'smooth' });
    };

    //clear saved parameters after 30 mins
    let t = sessionStorage.getItem("time");
    if (t) {
      if (moment().diff(moment(t), "minutes") > 30) {
        forgetUserSelections();
        return;
      }
    }

    if (dataContext.page) {
      const parsedPage = JSON.parse(dataContext.page.toString());
      setTab(parsedPage);
    }

    let cp = sessionStorage.getItem("coupon");
    if (cp) {
      dispatch({ type: "SET_DISCOUNT_COUPON", payload: JSON.parse(cp) });
    }

    let res: any = sessionStorage.getItem("reservationCreated");
    if (res) {
      res = !!JSON.parse(res);
      dataContext.changeReservationCreated(res);
    }

    dataContext.changeLanguage(uiLanguage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!dataContext.vehicle) return;
    setTotalPrice(dataContext.vehicle.onsale ?
        baseOnSalesPrice(dataContext.vehicle, dataContext.services, reservationDays)
        :
        basePrice(dataContext.vehicle, dataContext.services, reservationDays)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataContext.services, dataContext.vehicle, reservationDays]);

  if (!totalPrice && dataContext.vehicle) {
    // this is only for makeReservations page reload, totalPrice becomes undefined
    setTotalPrice(dataContext.vehicle.onsale ?
        baseOnSalesPrice(dataContext.vehicle, dataContext.services, reservationDays)
        :
        basePrice(dataContext.vehicle, dataContext.services, reservationDays)
    );
  }

  const scrollToTop = (scrollLocation: string = 'top') => {
    if (scrollLocation) {
      setTimeout(() => {
        document.getElementById(scrollLocation)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 0);
    }
  }

 const next = (data = null, scrollLocation = "top") => { //
    sessionStorage.setItem("services", JSON.stringify(dataContext.services));
    sessionStorage.setItem("page", JSON.stringify(activeTab + 1));
    if (data) {
      dataContext.changeCustomer(data)
    }
    dataContext.changeRoute('/makereservation');
    dataContext.changePage(activeTab + 1);
    setTab((v: number) => v + 1);
    scrollToTop(scrollLocation);
  }

  // TODO: Replace next() & Back() with a single function that takes a parameter to determine the direction like below
  const handleTabChange = (newTab: number) => {
    setTab(newTab);
    dataContext.changePage(newTab);
    sessionStorage.setItem("page", JSON.stringify(newTab));
  };

  const back = (optOffset: undefined | number, scrollLocation: string = "top") => {
    // 'optOffset' set when 'Add services' clicked at payment screen
    const offset = optOffset ?? 1;
    sessionStorage.setItem("page", JSON.stringify(activeTab - offset));
    dataContext.changePage(activeTab - offset);
    setTab((v: number) => v - offset);
    scrollToTop(scrollLocation);
  }

  const paymentRedirect = (e:any) => {
    //show loading
    dispatch({
      type: 'SET_API_MESSAGE',
      payload: translateService.translate('vehicleSearch1.creatingReservation'),
    });

    apiService?.reservation.createReservation(dataContext.reservation).then((response) => {
      let price = response.price;
      let resId = response.reservation;
      PurchaseGtagEvent(dataContext.gtagTracking ?? false,
          dataContext.reservation,
          dataContext.vehicle,
          dataContext.sendGaEvent,
          dataContext.getReservationDays(),
          price, resId);
      if (dataContext.services.paymentMethod === paymentMethod.PAYTRAIL) {
        apiService?.reservation.getPaytrailUrl(response.reservation, dataContext.customer?.phoneNumber).then((response2: any) => {
          // console.log('XXX PAYTRAIL: ', response2);
          dataContext.sendGaEvent('Paytrail', 'paytrailSuccess', '', 0);
          forgetUserSelections();
          setRedirectHome(true);
          window.location.href = response2.url;
        }).catch((e: {}) => {
          console.log(e);
          dispatch({
            type: 'SET_RESPONSE_MODAL',
            payload: translateService.translate('vehicleSearch1.redirectFailed')
          });
          dataContext.sendGaEvent('Paytrail', 'paytrailFail', '', 0);
          dataContext.changeReservationCreated(false); //for api 3 its response.id
          sessionStorage.setItem("reservationCreated", "false");
        });
      }

      // if one-way or onSales res: GA4 event is sent accordingly,
      // else, normal res: Payment method is checked to determine is Normal, Free or Quota res GA4 event
      if (dataContext.oneWayRes) {
        dataContext.sendGaEvent('createReservation', 'createReservationOneWaySuccess','', 0);
      } else if(dataContext.vehicle?.onsale?.extra) {
        dataContext.sendGaEvent('createReservation', 'createReservationExtraOnSalesSuccess', '', 0);
      } else if (dataContext.vehicle?.onsale) {
        dataContext.sendGaEvent('createReservation', 'createReservationOnSalesSuccess', '', 0);
      } else {
        if(dataContext.reservation.paymentMethod === 6) {
          dataContext.sendGaEvent('createReservation', 'createReservationFreeSuccess', '', 0);
        } else if (dataContext.reservation.paymentMethod === 3) {
          dataContext.sendGaEvent('createReservation', 'createReservationQuotaSuccess', '', 0);
        } else {
          dataContext.sendGaEvent('createReservation', 'createReservationSuccess', '', 0)
        }
      }
      dataContext.changeReservationCreated(response.reservation); //for api 3 its response.id
      sessionStorage.setItem("reservationCreated", "true");
      sessionStorage.setItem("resetDateTimes", '1');
    }).catch(e => {
      console.log(e);
      if (e.identifier === "API_ERROR_VEHICLE_NOT_AVAILABLE") {
        dispatch({
          type: 'SET_RESPONSE_MODAL',
          payload: translateService.translate('vehicleSearch1.notAvailable')
        });
      }
      else {
        if(typeof e === 'string' && e.includes("INVALID_BODY_ERROR")) {
          let errorString = e;
          dispatch({
            type: "SET_RESPONSE_MODAL",
            payload: translateService.translate('profileCompletenessPhase.messages.savingFailed') +
                " (Reason for error:  " + errorString.slice(28, errorString.indexOf("}\"")) + ")",
          });
        } else {
          if(typeof e === 'string' && e.includes("INVALID_STATE_ERROR - VehicleNotAvailable")) {
            dispatch({
              type: "SET_RESPONSE_MODAL",
              payload: translateService.translate('profileCompletenessPhase.messages.savingFailed') +
                  " (" + translateService.translate('vehicleSearch1.reasonForError') + translateService.translate('vehicleSearch1.vehicleNotAvailableAnymore') + ")",
            });
          } else {
            dispatch({
              type: "SET_RESPONSE_MODAL",
              payload: translateService.translate('profileCompletenessPhase.messages.savingFailed') + " (Reason for error:  " + e + ")",
            });
          }
        }
      }
      dataContext.sendGaEvent('createReservation', 'createReservationFail', '', 0);
    }).finally(() => {
      dispatch({
        type: 'SET_API_MESSAGE',
        payload: null,
      });
    });
  }

  function forgetUserSelections() {
    sessionStorage.setItem("route", "/");
    dataContext.clearSelections();
    dispatch({ type: "CLEAR_SELECTIONS", payload: null });
  }

  useEffect(() => {
    if (!dataContext.vehicle && !totalPrice && dataContext.route === "/makereservation") {
      setRedirectHome(true);
    };
  }, [dataContext.vehicle, totalPrice])

  const tabPage = (tab: number) => {
    switch (tab) {
      case 0:
        if (dataContext.vehicle?.availabilityData?.available)
          return <button onClick={() => {
            next()
          }}
                         className="btn btn-primary btn-outline-primary mt-2 w-100">
            <Translate content={'vehicleSearch.selectCar'} />
          </button>
        break;
      case 1:
        if (!dataContext.vehicle) {
          return (
              <div className={cx(styles.r24FullWidth, styles.r24TopMargin10)}>
                <div className={styles.r24FullWidth}>
                  Vehicle selection not found
                </div>
              </div>)
        } else {
          return (
              <SelectServices vehicle={dataContext.vehicle}
                              back={() => {setRedirectHome(true);
                                dataContext.sendGaEvent('reservation', 'backToSearchResults', '', 0)}}
                              next={() => {next();
                                if (!dataContext.authHashLogin) {
                                  dataContext.sendGaEvent('reservation', 'toCustomerForm', '', 0)
                                } else {
                                  dataContext.sendGaEvent('createCustomer', 'createCustomerSuccess', '', 0);
                                }
                              }}
                              reservationLength={reservationDays}/>)
        }
      case 2:
        if (!dataContext.authHashLogin) {
          return <>
            <CustomerInfoNew setShowLogin={setShowLogin} next={() => {
              if(dataContext.customer && dataContext.vehicle){
                if(dataContext.customer.dateOfBirth !== '' ||  dataContext.customer.personalIdCode !== '' || dataContext.user?.birthday || dataContext.customer.loggedIn){
                  if(isUnderTwentyOne(dataContext.customer.dateOfBirth || dataContext.user?.birthday, dataContext.customer.personalIdCode)
                      && dataContext.vehicle && dataContext.vehicle.vehicleData.noundertwentyone){
                    dataContext.changeTwentyModal(true);
                  } else {
                    next();
                  }
                }
              }
              dataContext.sendGaEvent('createCustomer', 'createCustomerSuccess', '', 0);
            }} back={back} />
          </>
        } else {
          return <PaymentInfo setRedirectHome={setRedirectHome}
                              reservationCreated={dataContext.reservationCreated}
                              back={back} next={paymentRedirect} reservationLength={reservationDays} />
        }
      case 3:
        return <PaymentInfo setRedirectHome={setRedirectHome}
                            reservationCreated={dataContext.reservationCreated}
                            back={back} next={paymentRedirect} reservationLength={reservationDays} />
    }
  }

  useEffect(() => {
    if(redirectHome) {
      dataContext.changeRoute('/');
      dataContext.changeSearchParameters({...dataContext.searchParameters, carId: null});
      sessionStorage.setItem('page', '0');
      sessionStorage.setItem('carIdChanged', 'true'); // if vehicle id in url param --> this disables using url id afterwards
    }
  }, [redirectHome])


  const modalPopupStyle = {
    content: {
      width: 'auto',
      minWidth: '200px',
      maxWidth: '769px',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'rgba(0,0,0,0.7)',
      color: 'white',
    },
    overlay: {
      zIndex: '1',
    },
  };

  return <>
    <ScrollingPage>
      <div className={styles.vehicleSearch}>
        <Modal isOpen={showLogin} style={modalPopupStyle} contentLabel='Login'>
          <LoginContainer
              setUser={(user: User) => dataContext.changeUser(user)}
              setIsLoggedIn={dataContext.changeLoggedIn}
              clearUserSelections={dataContext.clearSelections}
              setRedirect={() => {
                setShowLogin(false)
              }}
              sendGaEvent={dataContext.sendGaEvent}
              closeModal={() => setShowLogin(false)}
              appContext={dataContext.appContext ?? ''}
              rootUrl={dataContext.rootUrl ?? ''}
          />
        </Modal>
        <Steps onTabChange={handleTabChange}/>
        {(dataContext.vehicle && totalPrice) ? //&&user
            (<div style={{ padding: "10px", maxWidth: "768px", minWidth: "320px", display: (dataContext.vehicle && totalPrice) ? "block" : "none" }}
                  className={cx(styles.r24FullWidth, styles.grayBorderBottom, styles.r24Padding10, styles.r24BottomMargin10)}>
                  <VehicleResult setRedirect={setRedirect} vehicle={dataContext.vehicle}
                                 stars={dataContext.stars ? dataContext.stars[dataContext.vehicle.id] : undefined}
                                 totalPrice={totalPrice} discountValue={calculateDiscountValue(dataContext.vehicle, dataContext.services, reservationDays)}
                                 detailsVisible={0 === detailsVisible} setDetailsVisible={() => setDetailsVisible(() => { return 0 === detailsVisible ? -1 : 0 })}
                                 displaySticky discount={null} selectVehicle={() => { }}
                  />
                  {!dataContext.searchParameters ?
                      <div className={styles.carListing}>
                        <Card className={`card-body mb-4`}> Reservation details not found </Card>
                      </div>
                      : <ReservationTime carId={dataContext.vehicle?.id}/>
                  }
                  <span ref={topRef} id="top" />
                  {tabPage(activeTab)}
                </div>
            ) :
           null }
        {(!dataContext.vehicle && !totalPrice) ?
            (<div style={{padding: "10px", maxWidth: "768px", minWidth: "320px", display: (!dataContext.vehicle && !totalPrice) ? "block !important" : "none !important"}} className={cx(styles.r24FullWidth, styles.grayBorderBottom, styles.r24Padding10, styles.r24BottomMargin10)}>
              <h2 className="past-reservation-title my-3 text-center"> {translateService.translate('vehicleSearch.noVehicleSelectedOnReloadTitle')} </h2>
              <div className={styles.resultsLoaderDiv}>
              <span className={styles.resultsLoader}>  </span>
              </div>
        </div>) : null}
      </div>
    </ScrollingPage>
  </>;
}

export interface Customer {
  company: boolean,
  companyName: string,
  companyVatNumber: string,
  companyReference: string,
  familyName: string,
  givenName: string,
  unregisteredForeigner: boolean,
  registeredForeigner: boolean,
  personalIdCode: string,
  address: string,
  dateOfBirth: string,
  noBirthday: boolean,
  municipality: string,
  postalCode: string,
  country: string,
  secret: boolean,
  prepaid: boolean,
  phoneNumber: string,
  phoneNumber2: string,
  email: string,
  email2: string,
  additionalDriver: boolean,
  driverName: string,
  driverPhone: string,
  gdpr: boolean,
  agree: boolean,
  agree2: boolean,
  fairAccept: boolean,
  emailConsent: string,
  //member
  mayUseQuota: boolean,
  loggedIn: boolean //always true in chauffeur
  relativeBankTransferDueDate: number,
  mayUseBankTransferAnytime: boolean,
}